import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  FormControlLabel,
  makeStyles,
  Theme,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  Button,
  CheckBox,
  ICameraInfo,
  LightColors,
  Modal,
  Sliders,
  Typography,
} from "@thingsw/pitta-design-system";
import { Webviewer } from "../../contants/Breakpoints";
import Input from "@thingsw/pitta-design-system/dist/components/Input";
import {
  CAMERA,
  loadFirmwareSettings,
  TabNameInfo3,
  TrueFalsetype,
  updateFirmwareSettings,
} from "../../features/Camera/slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../features/store";
import _ from "lodash";
import { Selector } from "@thingsw/pitta-design-system/dist/components/Selector";
import ScheduledRebootTime from "../../contants/ScheduledRebootTime";
import LowvoltageTime from "../../contants/LowvoltageTime";
import LowvoltageVolt, {
  LowvoltageVolt_GPRO,
} from "../../contants/LowvoltageVolt";
import clsx from "clsx";
import ADASLDWS from "../../contants/ADASLDWS";
import { ISystemConfig } from "../../contants/Firmwares";
import { DMSPanel } from "./DMSPanel";
import {
  BATTERY_PROTECTION_WARNING_MODELS,
  OPTION_CAMERA_MODELS,
  TOUCH_SENSOR_MODELS,
} from "../../contants/Models";
import { FirmwareSlider } from "../FirmwareSlider";

const useStyles = makeStyles((theme: Theme) => ({
  bigBox: {
    width: "100%",
    minWidth: 288,
    border: `1px solid ${LightColors.primary["6"]}`,
    // minHeight: 1353,
    borderRadius: 4,
    marginBottom: 32,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      width: "100%",
      maxWidth: 672,
      // minHeight: 1171,
    },
  },
  boderBottomBox: {
    width: "100%",
    minWidth: 288,
    minHeight: 48,
    display: "flex",
    ...(theme.direction === "rtl"
      ? { paddingLeft: 16, paddingRight: 10 }
      : { paddingLeft: 10, paddingRight: 16 }),

    justifyContent: "center",
    flexDirection: "column",
    borderBottom: `1px solid ${LightColors.primary["6"]}`,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      maxWidth: 672,
      justifyContent: "space-between",
      flexDirection: "row",
      alignItems: "center",
    },
  },
  boderNoneBox: {
    width: "100%",
    minHeight: 48,
    alignItems: "center",
    ...(theme.direction === "rtl"
      ? { padding: "0 10px 0 16px" }
      : { padding: "0 16px 0 10px" }),
    justifyContent: "space-between",
    "&:last-child": {
      borderBottom: `1px solid ${LightColors.primary["6"]}`,
    },
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  boderBottomBoxSpace: {
    width: "100%",
    minWidth: 288,
    minHeight: 82,
    display: "flex",
    padding: "0 16px",
    flexDirection: "column",
    justifyContent: "center",
    borderBottom: `1px solid ${LightColors.primary["6"]}`,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      justifyContent: "space-between",
      flexDirection: "row",
      alignItems: "center",
      minHeight: 48,
      maxWidth: 672,
    },
  },
  BatteryBox: {
    width: "100%",
    minWidth: 288,
    minHeight: 82,
    display: "flex",
    padding: "0 16px 0 42px",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      justifyContent: "space-between",
      flexDirection: "row",
      alignItems: "center",
      minHeight: 48,
      maxWidth: 672,
    },
  },
  boxSpaceNoneCenter: {
    width: "100%",
    maxWidth: 672,
    minHeight: 48,
    display: "flex",
    padding: "0 16px",
    flexDirection: "column",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      justifyContent: "space-between",
      flexDirection: "row",
    },
  },
  mgNone: {
    margin: 0,
  },

  buttonSize: {
    width: "100%",
    marginBottom: 16,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      width: 96,
    },
  },
  wid224: {
    minWidth: 250,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      width: 280,
      ...(theme.direction === "rtl"
        ? { paddingRight: 22 }
        : { paddingLeft: 22 }),
    },
  },
  inputStyle: {
    minwidth: 256,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      minWidth: 342,
      marginTop: 6,
    },
  },
  inputValueStyle: {
    width: "94%",
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 12,
    marginTop: 3,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginBottom: 6,
    },
  },
  SflexEnd: {
    display: "flex",
    padding: "12px 0",
    justifyContent: "flex-end",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginBottom: 0,
      padding: 0,
    },
  },
  Width270: {
    minWidth: 260,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      minWidth: 270,
    },
  },
  Swid100: {
    maxWidth: 100,
    padding: "12px 0",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginBottom: 0,
      padding: 0,
    },
  },
  Swid98: {
    maxWidth: 98,
    padding: "12px 0",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginBottom: 0,
      padding: 0,
    },
  },
  Swid116: {
    maxWidth: 116,
    padding: "12px 0",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginBottom: 0,
      padding: 0,
    },
  },
  Swid192: {
    maxWidth: 192,
    padding: "12px 0",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginBottom: 0,
      padding: 0,
    },
  },
  SpdT12: {
    paddingTop: 12,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      paddingTop: 0,
    },
  },
  flex: {
    display: "flex",
  },
  flex1: {
    display: "flex",
    flex: 1,
  },
  flexEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
  spaceBetween: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  mgR8: {
    ...(theme.direction === "rtl" ? { marginLeft: 8 } : { marginRight: 8 }),
    maxWidth: 115,
  },
  mgR0: {
    ...(theme.direction === "rtl" ? { marginLeft: 0 } : { marginRight: 0 }),
    maxWidth: 115,
  },
  title: {
    paddingTop: 12,
    ...(theme.direction === "rtl" ? { paddingRight: 16 } : { paddingLeft: 16 }),
  },
  sliderText: {
    ...(theme.direction === "rtl" ? { marginRight: 25 } : { marginLeft: 25 }),
  },
  hardSliderDiv: {
    // [theme.breakpoints.down("sm")]: {
    //   paddingTop: 20,
    // },

    [theme.breakpoints.up("sm")]: {
      paddingTop: 20,
      display: "flex",
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: "unset",
    },
  },
  hardContentMargin: {
    marginLeft: 6,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 32,
    },
  },
  hardContentWeb: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  hardContentMobile: {
    paddingLeft: 5,
    paddingTop: 6,
  },
  hardLabelDiv: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: 34,
    },
  },
  hardLabel: {
    padding: "1px 0 0 2px",
  },
  recklessDiv: {
    paddingLeft: 15,
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      paddingTop: 3,
    },
  },
  recklessSwide: {
    maxWidth: 98,
    // mantis - 10755, 한줄로 보이도록 수정(Leehj)
    // padding: "2px 0 12px",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginBottom: 0,
      padding: 0,
    },
  },
  speedInput: {
    [theme.breakpoints.down("sm")]: {
      marginTop: 9,
    },
  },
  SpdT3: {
    paddingTop: 3,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      paddingTop: 0,
    },
  },
  SpdT21: {
    paddingTop: 22,
    paddingBottom: 6,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      paddingTop: 0,
    },
  },
  SpdT14: {
    paddingTop: 14,
    paddingBottom: 5,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      paddingTop: 0,
    },
  },
  adsT2: {
    marginTop: 2,
  },
  adasT8: {
    marginTop: 8,
  },
  adasT10: {
    marginTop: 10,
  },
  adasT14: {
    marginTop: 14,
  },
  voiceFlex: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
    },
  },
  volumeT12: {
    [theme.breakpoints.up("sm")]: {
      paddingTop: 12,
    },
  },
}));

const calcMPH = (unit: string, speed: string, defaultValue: string) => {
  if (speed === "0") {
    return defaultValue;
  }
  //mph
  if (unit === "1") {
    return speed;
  }
  // kmh
  return (parseFloat(speed) * 0.6213).toFixed(0);
};

const calcKMH = (unit: string, speed: string, defaultValue: string) => {
  if (speed === "0") {
    return defaultValue;
  }
  //mph
  if (unit === "1") {
    return (parseFloat(speed) * 1.6093).toFixed(0);
  }
  // kmh
  return speed;
};

export const SystemFirmwarePanel = () => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const mobile = useMediaQuery(theme.breakpoints.down(Webviewer.mobile));
  const {
    camera: cam,
    firmware,
    firmwareConfig,
    cameraList,
    loading,
  } = useSelector((state: RootState) => state[CAMERA]);
  const [current, setCurrent] = useState<TabNameInfo3>();

  const [batteryPRevChanged, setBatteryPRevChanged] = useState(false);
  const [batteryHRevChanged, setBatteryHRevChanged] = useState(false);
  const [cutoffTimerRevChanged, setCutoffTimerRevChanged] = useState(false);
  const [selectedField, setSelectedField] = useState<keyof TabNameInfo3>();
  const [selectedValue, setSelectedValue] = useState<any>();
  const [openBatteryModal, setOpenBatteryModal] = useState(false);
  const [disabledChange, setDisabledChange] = useState(true);
  const [camera, setCamera] = useState<ICameraInfo>();

  const settings = useMemo(() => {
    return firmwareConfig?.System;
  }, [firmwareConfig?.System]);

  const OPTION_MODEL = useMemo(() => {
    return _.includes(OPTION_CAMERA_MODELS, camera?.model);
  }, [camera?.model]);

  const PSENSORMODEL = useMemo(
    () =>
      _.includes(
        ["DR900S-1CH", "DR900S-2CH", "DR750S-1CH", "DR750S-2CH"],
        camera?.model
      ),
    [camera?.model]
  );

  // 배터리 protection 변경 경고 모델 추가 (7434)
  const BATTERY_PROTECTION_MODAL = useMemo(
    () => _.includes(BATTERY_PROTECTION_WARNING_MODELS, camera?.model),
    [camera?.model]
  );

  const DR750GPRO = useMemo(
    () =>
      _.includes(
        ["DR750G Pro", "DR750G-1CH Pro", "DR750G-2CH Pro"],
        camera?.model
      ),
    [camera?.model]
  );

  const FILE_LOCKED = useMemo(
    () => _.includes(["DR750G Pro", "BlackVue 7G Pro"], camera?.model),
    [camera?.model]
  );

  // mantis - 8601
  // BlackVue 9 LTE 모델 >> 긴급녹화 기능만 select 옵션에 나타나도록 includes에 추가함.
  //mantis - 8833, "BlackVue 7 LTE","BlackVue 9 LTE"모델 추가 (Leehj)

  const SigmaStar_MODEL = useMemo(
    () =>
      _.includes(
        [
          "DR770X",
          "BlackVue 7G Pro",
          "DR770X Box",
          "DR770X LTE",
          "DR970X",
          "DR970X LTE",
        ],

        camera?.model
      ),
    [camera?.model]
  );

  // 0010174
  const PSensorTitle = useMemo(() => {
    if (_.includes(TOUCH_SENSOR_MODELS, camera?.model)) {
      return "Touch sensor";
    }
    if (camera?.model === "DR770X Box") {
      return "SOS button";
    }
    return "Proximity sensor";
  }, [camera?.model]);

  const openBatteryLowVolt = useMemo(() => {
    if (BATTERY_PROTECTION_MODAL && !batteryPRevChanged) {
      return false;
    } else {
      return undefined;
    }
  }, [BATTERY_PROTECTION_MODAL, batteryPRevChanged]);

  const openCutoff = useMemo(() => {
    if (BATTERY_PROTECTION_MODAL && !cutoffTimerRevChanged) {
      return false;
    } else {
      return undefined;
    }
  }, [BATTERY_PROTECTION_MODAL, cutoffTimerRevChanged]);

  const DR7500GPRO_BT_ORDER = useMemo(() => {
    const fwVer = parseFloat(camera?.fw_ver ?? "1.000");
    return fwVer >= 1.005 && camera?.model === "DR750G Pro";
  }, [camera?.fw_ver, camera?.model]);

  const PSENSOROptions = useMemo(() => {
    if (PSENSORMODEL) {
      return [
        {
          key: "0",
          value: "Voice recording on/off",
        },
        {
          key: "1",
          value: "Manual recording",
        },
      ];
    } else if (DR750GPRO) {
      return [
        {
          key: "1",
          value: "Manual recording (File locked)",
        },
        {
          key: "2",
          value: "Voice recording on/off",
        },
      ];
    } else {
      return [
        {
          key: "1",
          value: "Manual recording",
        },
        {
          key: "2",
          value: "Voice recording on/off",
        },
      ];
    }
  }, [PSENSORMODEL, DR750GPRO]);

  const TSENSOROptions = useMemo(() => {
    if (FILE_LOCKED) {
      return [
        {
          key: "1",
          value: "Manual recording (File locked)",
        },
      ];
    } else {
      return [
        {
          key: "1",
          value: "Manual recording",
        },
      ];
    }
  }, [FILE_LOCKED]);

  useEffect(() => {
    const dev = _.find(
      cameraList?.deviceListInfo,
      (dev) => dev.device.psn === cam?.psn
    )?.device;
    setCamera((c) => {
      if (c?.psn === dev?.psn) {
        return c;
      } else {
        return dev;
      }
    });
  }, [cam?.psn, cameraList]);

  useEffect(() => {
    if (camera) {
      dispatch(loadFirmwareSettings(camera.psn));
    }
  }, [dispatch, camera]);

  useEffect(() => {
    if (firmware) {
      const currentTab = _.find(
        firmware.cloud_settings,
        (c) => c.section_name === "Tab3"
      );

      if (currentTab) {
        const section = _.cloneDeep(currentTab.section_info) as TabNameInfo3;
        if (settings?.BatteryProtectionRev) {
          const battRev = settings.BatteryProtectionRev;
          switch (section.LowvoltageTime) {
            case "1":
              section.LowvoltageTime = "600";
              break;
            case "2":
              section.LowvoltageTime = "1200";
              break;
            case "3":
              section.LowvoltageTime = "2400";
              break;
            case "4":
              section.LowvoltageTime = "4800";
              break;
          }

          if (section.LowvoltageVolt !== "0") {
            if (_.includes(["1", "2", "3"], section.LowvoltageVolt)) {
              const volt = section.LowvoltageVolt;
              section.LowvoltageVolt = battRev.LowvoltageVolt[volt];
              section.LowvoltageVoltHeavy = battRev.LowvoltageVoltHeavy[volt];
            }

            let lowVal = parseInt(section.LowvoltageVolt) / 100;
            if (lowVal > battRev.maxVolt || lowVal < battRev.minVolt) {
              lowVal = battRev.defaultVolt;
            }
            section.LowvoltageVolt = (lowVal * 100).toString();
          }

          if (section.LowvoltageVoltHeavy) {
            let lowHeavyVal = parseInt(section.LowvoltageVoltHeavy) / 100;

            if (
              lowHeavyVal > battRev.maxVoltHeavy ||
              lowHeavyVal < battRev.minVoltHeavy
            ) {
              lowHeavyVal = battRev.defaultVoltHeavy;
            }
            section.LowvoltageVoltHeavy = (lowHeavyVal * 100).toString();
          }
        }
        setCurrent(section);
      }
    }
  }, [firmware, settings?.BatteryProtectionRev]);

  const getBoolean = useCallback((TrueFalse?: TrueFalsetype) => {
    return TrueFalse === "1" ? true : false;
  }, []);

  const handleChange = useCallback(
    (key: keyof TabNameInfo3, value: boolean | string) => {
      if (typeof value === "boolean") {
        setCurrent((c) => ({ ...c, [key]: value ? "1" : "0" } as TabNameInfo3));
      } else if (typeof value === "string") {
        setCurrent((c) => ({ ...c, [key]: value } as TabNameInfo3));
      }
    },
    []
  );

  const handleChangePSENSOR = useCallback(
    (key: keyof TabNameInfo3, checked: boolean) => {
      setCurrent(
        (c) => ({ ...c, [key]: checked ? "2" || "1" : "0" } as TabNameInfo3)
      );
    },
    []
  );

  const handleChangeTSENSOR = useCallback(
    (key: keyof TabNameInfo3, checked: boolean) => {
      setCurrent((c) => ({ ...c, [key]: checked ? "1" : "0" } as TabNameInfo3));
    },
    []
  );

  //900s / 750s 모델만 다른 모델과 상이한 키를 갖고 있음
  const handleChangePSENSOR_MODEL = useCallback(
    (key: keyof TabNameInfo3, checked: boolean) => {
      setCurrent(
        (c) => ({ ...c, [key]: checked ? "0" || "1" : "2" } as TabNameInfo3)
      );
    },
    []
  );

  const handleChangeLowVolt = useCallback(
    (key: keyof TabNameInfo3, checked: boolean) => {
      setCurrent((c) => ({ ...c, [key]: checked ? "2" : "0" } as TabNameInfo3));
    },
    []
  );

  const handleChangeCutoffTimerRev = useCallback(
    (key: keyof TabNameInfo3, checked: boolean) => {
      if (BATTERY_PROTECTION_MODAL) {
        setOpenBatteryModal(true);
      }
      const val = settings?.BatteryProtectionRev?.defaultTime ?? "1200";
      setCurrent(
        (c) =>
          ({
            ...c,
            [key]: checked ? val : "0",
          } as TabNameInfo3)
      );
    },
    [BATTERY_PROTECTION_MODAL, settings?.BatteryProtectionRev?.defaultTime]
  );

  const handleChangeLowVoltRev = useCallback(
    (key: keyof TabNameInfo3, checked: boolean) => {
      if (BATTERY_PROTECTION_MODAL) {
        setOpenBatteryModal(true);
      }
      const dVolt = (
        (settings?.BatteryProtectionRev?.defaultVolt ?? 12) * 100
      ).toString();
      setCurrent(
        (c) =>
          ({
            ...c,
            [key]: checked ? dVolt : "0",
          } as TabNameInfo3)
      );
    },
    [BATTERY_PROTECTION_MODAL, settings]
  );

  const handleChangeSpeed = useCallback(
    (key: keyof TabNameInfo3, checked: boolean) => {
      setCurrent(
        (c) => ({ ...c, [key]: checked ? "0" || "1" : "2" } as TabNameInfo3)
      );
    },
    []
  );

  useEffect(() => {
    if (firmware) {
      const currentTab = _.find(
        firmware.cloud_settings,
        (c) => c.section_name === "Tab3"
      );
      const predicts = _.keys(currentTab?.section_info as TabNameInfo3).map(
        (k) => {
          const key = k as keyof TabNameInfo3;
          return (
            (currentTab?.section_info as TabNameInfo3)[key] === current?.[key]
          );
        }
      );
      setDisabledChange(
        _.every(predicts) ||
          current?.kmLimit === "" ||
          current?.mileLimit === "" ||
          // 8739 - 이벤트 고도화 1차 - 속도경고 설정값 비어있는 경우 저장안되게 수정
          current?.AlertLimit === ""
      );
    }
  }, [firmware, current]);

  const handleInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (current) {
        const { value } = e.target;
        const regex = new RegExp(/((?![a-zA-Z0-9:;'/\\+-_()$#]).)/gm);
        // eslint-disable-next-line no-useless-escape
        const regex2 = /[\[\]\=?^,.<>@]/gi;

        const test = regex.test(value);
        const test2 = regex2.test(value);
        if (value.length <= 20) {
          if (!test && !test2) {
            setCurrent((c) => {
              return c && { ...c, userString: value };
            });
          }
        }
      }
    },
    [current]
  );

  const handleSpeedEventRev2 = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (current) {
        const { value } = e.target;
        const regex = new RegExp(/((?![0-9]).)/gm);

        const test = regex.test(value);
        console.log(value, test);
        if (!test) {
          if (
            current?.EventSpeedUnit === "1" &&
            ((parseInt(e.target.value) <= 199 &&
              // mantis : 8716
              // Speed alert 체크 시 1부터 입력 가능하도록 수정
              parseInt(e.target.value) >= 1) ||
              e.target.value === "")
          ) {
            setCurrent((c) => {
              return (
                c && {
                  ...c,
                  // 8739 - 이벤트 고도화 1차 - 속도경고 설정값 변수 수정
                  AlertLimit: value,
                }
              );
            });
            // 8772 - MPH를 선택한 경우 아래 실행문 실행되지 않도록 조건 추가
          } else if (
            current?.EventSpeedUnit !== "1" &&
            ((parseInt(e.target.value) <= 299 &&
              // mantis : 8716
              // Speed alert 체크 시 1부터 입력 가능하도록 수정
              parseInt(e.target.value) >= 1) ||
              e.target.value === "")
          ) {
            setCurrent((c) => {
              return (
                c && {
                  ...c,
                  // 8739 - 이벤트 고도화 1차 - 속도경고 설정값 변수 수정
                  AlertLimit: value,
                }
              );
            });
          }
        }
      }
    },
    [current]
  );

  const handleSpeed = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (current) {
        const { value } = e.target;
        const regex = new RegExp(/((?![0-9]).)/gm);

        const test = regex.test(value);
        console.log(value, test);
        if (!test) {
          if (
            current?.SpeedAlert === "0" &&
            ((parseInt(e.target.value) <= 299 &&
              parseInt(e.target.value) >= 0) ||
              e.target.value === "")
          ) {
            console.log("setCurrent");
            setCurrent((c) => {
              return (
                c && {
                  ...c,
                  kmLimit: value,
                }
              );
            });
          } else if (
            current?.SpeedAlert === "1" &&
            ((parseInt(e.target.value) <= 199 &&
              parseInt(e.target.value) >= 0) ||
              e.target.value === "")
          ) {
            setCurrent((c) => {
              return (
                c && {
                  ...c,
                  mileLimit: value,
                }
              );
            });
          }
        }
      }
    },
    [current]
  );

  const handleUpdate = () => {
    if (current && camera && firmware) {
      const updated = {
        ...firmware,
        cloud_settings: _.filter(
          firmware.cloud_settings,
          (c) => c.section_name !== "Tab3"
        ),
      };
      updated.cloud_settings = [
        { section_info: current, section_name: "Tab3" },
        ...updated.cloud_settings,
      ];
      dispatch(updateFirmwareSettings({ firmware: updated }));
    }
  };

  /* REV 부터 적용되는 신규 Battery protection UI */
  const batteryRevMarkup = useMemo(() => {
    if (settings?.["BatteryProtectionRev"]) {
      console.log("LowvoltageVolt", current?.LowvoltageVolt);
      const batteryProtectionRev = settings.BatteryProtectionRev;
      const volt =
        current?.LowvoltageVolt !== undefined && current?.LowvoltageVolt !== "0"
          ? _.round(parseFloat(current.LowvoltageVolt) / 100, 1)
          : batteryProtectionRev.defaultVolt;

      const voltHeavy =
        current?.LowvoltageVoltHeavy !== undefined &&
        current?.LowvoltageVoltHeavy !== "0"
          ? _.round(parseFloat(current.LowvoltageVoltHeavy) / 100, 1)
          : batteryProtectionRev.defaultVoltHeavy;
      let voltTime =
        current?.LowvoltageTime !== undefined && current?.LowvoltageTime !== "0"
          ? current.LowvoltageTime
          : batteryProtectionRev.defaultTime;
      const len = voltTime.length;
      voltTime = voltTime.substring(0, len - 2) + ":00";

      return (
        <>
          <div className={clsx(classes.boderNoneBox, classes.adasT8)}>
            <FormControlLabel
              className={classes.mgNone}
              control={
                <CheckBox
                  checked={current?.Battery !== "0"}
                  onChange={(e) => {
                    if (BATTERY_PROTECTION_MODAL) {
                      setOpenBatteryModal(true);
                      setSelectedField("Battery");
                      setSelectedValue(e.target.checked);
                    } else {
                      handleChange("Battery", e.target.checked);
                    }
                  }}
                  color="primary"
                />
              }
              label={
                <Typography category="Default" variant="BodyBold">
                  {t("Battery protection")}
                </Typography>
              }
            />
          </div>
          <div className={classes.boderBottomBox} style={{ border: "none" }}>
            <FormControlLabel
              className={classes.mgNone}
              control={
                <CheckBox
                  disabled={current?.Battery !== "1"}
                  checked={current?.LowvoltageVolt !== "0"}
                  onChange={(e) => {
                    if (BATTERY_PROTECTION_MODAL) {
                      setOpenBatteryModal(true);
                      setSelectedField("LowvoltageVolt");
                      setSelectedValue(e.target.checked);
                    } else {
                      handleChangeLowVoltRev(
                        "LowvoltageVolt",
                        e.target.checked
                      );
                    }
                  }}
                  color="primary"
                />
              }
              label={
                <Typography category="Default" variant="Body">
                  {t("Low voltage cut-off")}
                </Typography>
              }
            />
          </div>
          <div className={classes.BatteryBox}>
            <div>
              <Typography category="Default" variant="Body">
                {t("Passenger vehicle")}
              </Typography>
            </div>
            <div className={classes.flexEnd}>
              <div className={classes.Swid116} style={{ maxWidth: 187 }}>
                <Input
                  dense
                  countDense
                  readOnly
                  disabled={
                    current?.LowvoltageVolt === "0" || current?.Battery !== "1"
                  }
                  PlusButtonDis={
                    current?.LowvoltageVolt === "0" ||
                    current?.Battery !== "1" ||
                    volt.toFixed(1) === batteryProtectionRev.maxVolt.toFixed(1)
                  }
                  MinusButtonDis={
                    current?.LowvoltageVolt === "0" ||
                    current?.Battery !== "1" ||
                    volt.toFixed(1) === batteryProtectionRev.minVolt.toFixed(1)
                  }
                  defaultText={"/12.5 V"}
                  onPlus={() => {
                    if (current?.LowvoltageVolt) {
                      if (BATTERY_PROTECTION_MODAL && !batteryPRevChanged) {
                        setOpenBatteryModal(true);
                        setSelectedField("LowvoltageVolt");
                        setSelectedValue(undefined);
                      } else {
                        current.LowvoltageVolt = (
                          _.round(volt + 0.1, 1) * 100
                        ).toString();
                        setCurrent({ ...current });
                      }
                    }
                  }}
                  onMinus={() => {
                    if (current?.LowvoltageVolt) {
                      if (BATTERY_PROTECTION_MODAL && !batteryPRevChanged) {
                        setOpenBatteryModal(true);
                        setSelectedField("LowvoltageVolt");
                        setSelectedValue(undefined);
                      } else {
                        current.LowvoltageVolt = (
                          _.round(volt - 0.1, 1) * 100
                        ).toString();
                        setCurrent({ ...current });
                      }
                    }
                  }}
                  onChange={(e) => {
                    if (current?.LowvoltageVolt !== undefined) {
                      if (BATTERY_PROTECTION_MODAL && !batteryPRevChanged) {
                        setOpenBatteryModal(true);
                        setSelectedField("LowvoltageVolt");
                        setSelectedValue(undefined);
                      } else {
                        current.LowvoltageVolt = e.target.value;
                        setCurrent({ ...current });
                      }
                    }
                  }}
                  value={volt.toFixed(1)}
                />
              </div>
            </div>
          </div>
          <div className={classes.BatteryBox}>
            <div>
              <Typography category="Default" variant="Body">
                {t("Heavy vehicle")}
              </Typography>
            </div>
            <div className={classes.flexEnd}>
              <div className={classes.Swid116} style={{ maxWidth: 174 }}>
                <Input
                  dense
                  countDense
                  readOnly
                  disabled={
                    current?.LowvoltageVolt === "0" || current?.Battery !== "1"
                  }
                  PlusButtonDis={
                    current?.LowvoltageVolt === "0" ||
                    current?.Battery !== "1" ||
                    voltHeavy.toFixed(1) ===
                      batteryProtectionRev.maxVoltHeavy.toFixed(1)
                  }
                  MinusButtonDis={
                    current?.LowvoltageVolt === "0" ||
                    current?.Battery !== "1" ||
                    voltHeavy.toFixed(1) ===
                      batteryProtectionRev.minVoltHeavy.toFixed(1)
                  }
                  onPlus={() => {
                    if (current?.LowvoltageVoltHeavy) {
                      if (BATTERY_PROTECTION_MODAL && !batteryHRevChanged) {
                        setOpenBatteryModal(true);
                        setSelectedField("LowvoltageVoltHeavy");
                        setSelectedValue(undefined);
                      } else {
                        current.LowvoltageVoltHeavy = (
                          _.round(voltHeavy + 0.1, 1) * 100
                        ).toString();
                        setCurrent({ ...current });
                      }
                    }
                  }}
                  onMinus={() => {
                    if (current?.LowvoltageVoltHeavy) {
                      if (BATTERY_PROTECTION_MODAL && !batteryHRevChanged) {
                        setOpenBatteryModal(true);
                        setSelectedField("LowvoltageVoltHeavy");
                        setSelectedValue(undefined);
                      } else {
                        current.LowvoltageVoltHeavy = (
                          _.round(voltHeavy - 0.1, 1) * 100
                        ).toString();
                        setCurrent({ ...current });
                      }
                    }
                  }}
                  onChange={(e) => {
                    if (current?.LowvoltageVoltHeavy !== undefined) {
                      if (BATTERY_PROTECTION_MODAL && !batteryHRevChanged) {
                        setOpenBatteryModal(true);
                        setSelectedField("LowvoltageVoltHeavy");
                        setSelectedValue(undefined);
                      } else {
                        current.LowvoltageVoltHeavy = e.target.value;
                        setCurrent({ ...current });
                      }
                    }
                  }}
                  defaultText={"/24 V"}
                  value={voltHeavy.toFixed(1)}
                />
              </div>
            </div>
          </div>
          <div className={classes.boderBottomBox}>
            <FormControlLabel
              className={classes.mgNone}
              control={
                <CheckBox
                  disabled={current?.Battery !== "1"}
                  checked={current?.LowvoltageTime !== "0"}
                  onChange={(e) => {
                    if (BATTERY_PROTECTION_MODAL) {
                      setOpenBatteryModal(true);
                      setSelectedField("LowvoltageTime");
                      setSelectedValue(e.target.checked);
                    } else {
                      handleChangeCutoffTimerRev(
                        "LowvoltageTime",
                        e.target.checked
                      );
                    }
                  }}
                  color="primary"
                />
              }
              label={
                <Typography category="Default" variant="Body">
                  {t("Cut-off timer")}
                </Typography>
              }
            />
            <div className={classes.flexEnd}>
              <div className={classes.Swid98} style={{ maxWidth: 204 }}>
                <Input
                  readOnly
                  disabled={
                    current?.LowvoltageTime === "0" || current?.Battery !== "1"
                  }
                  PlusButtonDis={
                    current?.LowvoltageTime === "0" ||
                    current?.Battery !== "1" ||
                    current?.LowvoltageTime === batteryProtectionRev.maxTime
                  }
                  MinusButtonDis={
                    current?.LowvoltageTime === "0" ||
                    current?.Battery !== "1" ||
                    current?.LowvoltageTime === batteryProtectionRev.minTime
                  }
                  dense
                  countDense
                  onPlus={() => {
                    const val = voltTime.replace(":", "");
                    if (current?.LowvoltageTime) {
                      if (BATTERY_PROTECTION_MODAL && !cutoffTimerRevChanged) {
                        setOpenBatteryModal(true);
                        setSelectedField("LowvoltageTime");
                        setSelectedValue(undefined);
                      } else {
                        current.LowvoltageTime = (
                          parseInt(val) + 100
                        ).toString();
                        setCurrent({ ...current });
                      }
                    }
                  }}
                  onMinus={() => {
                    const val = voltTime.replace(":", "");
                    if (current?.LowvoltageTime) {
                      if (BATTERY_PROTECTION_MODAL && !cutoffTimerRevChanged) {
                        setOpenBatteryModal(true);
                        setSelectedField("LowvoltageTime");
                        setSelectedValue(undefined);
                      } else {
                        current.LowvoltageTime = (
                          parseInt(val) - 100
                        ).toString();
                        setCurrent({ ...current });
                      }
                    }
                  }}
                  onChange={(e) => {
                    if (current?.LowvoltageTime !== undefined) {
                      setCutoffTimerRevChanged(true);
                      current.LowvoltageTime = e.target.value;
                      setCurrent({ ...current });
                    }
                  }}
                  defaultText={"/48:00 H"}
                  value={voltTime}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    return <></>;
  }, [
    BATTERY_PROTECTION_MODAL,
    batteryHRevChanged,
    batteryPRevChanged,
    classes.BatteryBox,
    classes.Swid116,
    classes.Swid98,
    classes.adasT8,
    classes.boderBottomBox,
    classes.boderNoneBox,
    classes.flexEnd,
    classes.mgNone,
    current,
    cutoffTimerRevChanged,
    handleChange,
    handleChangeCutoffTimerRev,
    handleChangeLowVoltRev,
    settings,
    t,
  ]);

  const speedAlertMarkup = useMemo(() => {
    if (settings?.["EventRev2"]) {
      return (
        <>
          <div className={clsx(classes.boderNoneBox, classes.recklessDiv)}>
            <div>
              <Typography category="Default" variant="BodyBold">
                {t("Reckless driving")}
              </Typography>
            </div>
            <div className={classes.recklessSwide}>
              <Selector
                t={t}
                keyValue={current?.EventSpeedUnit ?? "0"}
                dense
                mobile={mobile}
                onChange={(e) => {
                  setCurrent((c) => {
                    return (
                      c && {
                        ...c,
                        EventSpeedUnit: e.key,
                        // 10046 이슈로 인해서, 초기값 변경
                        AlertLimit: "0",
                        AccelLimit: e.key === "1" ? "7" : "11",
                        HarshLimit: e.key === "1" ? "8" : "13",
                        SharpLimit: e.key === "1" ? "9" : "15",
                      }
                    );
                  });
                }}
                items={[
                  {
                    key: "0",
                    value: "km/h",
                  },
                  {
                    key: "1",
                    value: "MPH",
                  },
                ]}
              />
            </div>
          </div>
          <div className={clsx(classes.boderNoneBox, classes.SpdT3)}>
            <FormControlLabel
              className={classes.mgNone}
              control={
                <CheckBox
                  checked={current?.AlertLimit !== "0"}
                  onChange={(e) => {
                    setCurrent((c) => {
                      return (
                        c && {
                          ...c,
                          AlertLimit: e.target.checked
                            ? current?.EventSpeedUnit === "1"
                              ? "62"
                              : "100"
                            : "0",
                        }
                      );
                    });
                  }}
                  color="primary"
                />
              }
              label={
                <Typography
                  category="Default"
                  variant="Body"
                  style={{ padding: "2px 0 0 1px" }}
                >
                  {t("Speed alert")}
                </Typography>
              }
            />

            <div className={clsx(classes.flexEnd, classes.speedInput)}>
              <div className={classes.flex}>
                <Input
                  disabled={current?.AlertLimit === "0"}
                  dense
                  defaultText={
                    current?.EventSpeedUnit === "1" ? "of 199" : "of 299"
                  }
                  className={classes.mgR0}
                  // mantis - 8757, 체크 off한 경우 default UI 변경 -> km면 100 , MPH면 62
                  value={
                    current?.AlertLimit === "0"
                      ? current?.EventSpeedUnit === "1"
                        ? "62"
                        : "100"
                      : current?.AlertLimit
                  }
                  onChange={handleSpeedEventRev2}
                ></Input>
              </div>
            </div>
          </div>
        </>
      );
    } else if (settings?.["SpeedAlert"]) {
      return (
        <>
          <div className={clsx(classes.boderNoneBox, classes.recklessDiv)}>
            <div>
              <Typography category="Default" variant="BodyBold">
                {t("Reckless driving")}
              </Typography>
            </div>
            <div className={classes.recklessSwide}>
              <Selector
                t={t}
                keyValue={current?.SpeedAlert}
                disabled={current?.SpeedAlert === "2"}
                dense
                mobile={mobile}
                onChange={(e) => {
                  setCurrent((c) => {
                    return c && { ...c, SpeedAlert: e.key };
                  });
                }}
                items={[
                  {
                    key: "0",
                    value: "km/h",
                  },
                  {
                    key: "1",
                    value: "MPH",
                  },
                ]}
              />
            </div>
          </div>
          <div className={clsx(classes.boderNoneBox, classes.SpdT3)}>
            <FormControlLabel
              className={classes.mgNone}
              control={
                <CheckBox
                  checked={
                    current?.SpeedAlert === "1" || current?.SpeedAlert === "0"
                  }
                  onChange={(e) => {
                    handleChangeSpeed("SpeedAlert", e.target.checked);
                  }}
                  color="primary"
                />
              }
              label={
                <Typography
                  category="Default"
                  variant="Body"
                  style={{ padding: "2px 0 0 1px" }}
                >
                  {t("Speed alert")}
                </Typography>
              }
            />

            <div className={clsx(classes.flexEnd, classes.speedInput)}>
              <div className={classes.flex}>
                <Input
                  disabled={current?.SpeedAlert === "2"}
                  dense
                  defaultText={
                    current?.SpeedAlert === "1" ? "of 200" : "of 300"
                  }
                  className={classes.mgR0}
                  value={
                    current?.SpeedAlert === "1"
                      ? current?.mileLimit
                      : current?.kmLimit
                  }
                  onChange={handleSpeed}
                ></Input>
              </div>
            </div>
          </div>
        </>
      );
    }
    return <></>;
  }, [
    classes.SpdT3,
    classes.boderNoneBox,
    classes.flex,
    classes.flexEnd,
    classes.mgNone,
    classes.mgR0,
    classes.recklessDiv,
    classes.recklessSwide,
    classes.speedInput,
    current?.AlertLimit,
    current?.EventSpeedUnit,
    current?.SpeedAlert,
    current?.kmLimit,
    current?.mileLimit,
    handleChangeSpeed,
    handleSpeed,
    handleSpeedEventRev2,
    mobile,
    settings,
    t,
  ]);

  const eventRevMarkup = useMemo(() => {
    if (settings?.["EventRev"]) {
      return (
        <>
          <div
            className={clsx(classes.boderBottomBox, classes.SpdT12)}
            style={{ paddingTop: 6, paddingBottom: 6 }}
          >
            <div>
              <FormControlLabel
                className={classes.mgNone}
                control={
                  <CheckBox
                    checked={current?.AccelEvent === "1"}
                    onChange={(e) => {
                      handleChange("AccelEvent", e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label={
                  <Typography category="Default" variant="Body">
                    {t("Acceleration")}
                  </Typography>
                }
              />

              <div style={{ marginLeft: 32 }}>
                <Typography
                  category="Default"
                  variant="Small"
                  htmlColor={LightColors.primary["2"]}
                >
                  {/* mantis - 8740, kmh/mph에 값 추가 */}
                  {t("Hard acceleration event_", {
                    kmh: "11",
                    mph: "7",
                  })}
                </Typography>
              </div>
            </div>
          </div>

          <div
            className={clsx(classes.boderBottomBox, classes.SpdT12)}
            style={{ paddingTop: 6, paddingBottom: 6 }}
          >
            <div>
              <FormControlLabel
                className={classes.mgNone}
                control={
                  <CheckBox
                    checked={current?.HarshEvent === "1"}
                    onChange={(e) => {
                      handleChange("HarshEvent", e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label={
                  <Typography category="Default" variant="Body">
                    {t("Hard braking")}
                  </Typography>
                }
              />

              <div style={{ marginLeft: 32 }}>
                <Typography
                  category="Default"
                  variant="Small"
                  htmlColor={LightColors.primary["2"]}
                >
                  {/* mantis - 8740, kmh/mph에 값 추가 */}
                  {t("Hard braking event_", {
                    kmh: "13",
                    mph: "8",
                  })}
                </Typography>
              </div>
            </div>
          </div>

          <div
            className={clsx(classes.boderBottomBox, classes.SpdT12)}
            style={{ paddingTop: 6, paddingBottom: 6 }}
          >
            <div>
              <FormControlLabel
                className={classes.mgNone}
                control={
                  <CheckBox
                    checked={current?.SharpEvent === "1"}
                    onChange={(e) => {
                      handleChange("SharpEvent", e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label={
                  <Typography category="Default" variant="Body">
                    {/* osd 키값 참고 */}
                    {t("Sharp turn")}
                  </Typography>
                }
              />

              <div style={{ marginLeft: 32 }}>
                <Typography
                  category="Default"
                  variant="Small"
                  htmlColor={LightColors.primary["2"]}
                >
                  {/* mantis - 8740, kmh/mph에 값 추가 */}
                  {t("Hard cornering event_", {
                    kmh: "15",
                    mph: "9",
                  })}
                </Typography>
              </div>
            </div>
          </div>
        </>
      );
    } else if (settings?.["EventRev2"]) {
      return (
        <>
          <div className={clsx(classes.boderNoneBox, classes.SpdT21)}>
            <div className={classes.hardSliderDiv}>
              <div style={{ minWidth: 170 }}>
                <FormControlLabel
                  className={clsx(classes.mgNone, classes.hardLabelDiv)}
                  control={
                    <CheckBox
                      style={{ paddingRight: 5 }}
                      checked={current?.AccelLimit !== "0"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          handleChange(
                            "AccelLimit",
                            current?.EventSpeedUnit === "1" ? "7" : "11"
                          );
                        } else {
                          handleChange("AccelLimit", "0");
                        }
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography category="Default" variant="Body">
                      {t("Acceleration")}
                    </Typography>
                  }
                />

                <div
                  className={clsx(
                    classes.hardContentMargin,
                    classes.hardContentWeb
                  )}
                >
                  <Typography
                    category="Default"
                    variant="Small"
                    htmlColor={LightColors.primary["2"]}
                  >
                    {t("Hard acceleration event_", {
                      kmh: calcKMH(
                        current?.EventSpeedUnit ?? "0",
                        current?.AccelLimit ?? "0",
                        "11"
                      ),
                      mph: calcMPH(
                        current?.EventSpeedUnit ?? "0",
                        current?.AccelLimit ?? "0",
                        "7"
                      ),
                    })}
                  </Typography>
                </div>
              </div>
              <div>
                <FirmwareSlider
                  max={current?.EventSpeedUnit === "1" ? 37 : 60}
                  min={current?.EventSpeedUnit === "1" ? 6 : 10}
                  mark={current?.EventSpeedUnit === "1" ? 7 : 11}
                  step={1}
                  value={parseInt(
                    current?.AccelLimit === undefined ||
                      current?.AccelLimit === "0"
                      ? current?.EventSpeedUnit === "1"
                        ? "7"
                        : "11"
                      : current?.AccelLimit
                  )}
                  disabled={current?.AccelLimit === "0"}
                  onChange={(e, value) => {
                    const v = value as number;
                    setCurrent((c) => {
                      return (
                        c && {
                          ...c,
                          AccelLimit: v.toString(),
                        }
                      );
                    });
                  }}
                />
                {mobile && (
                  <div className={classes.hardContentMobile}>
                    <Typography
                      category="Default"
                      variant="Small"
                      htmlColor={LightColors.primary["2"]}
                    >
                      {/* mantis - 8759, AccelEvent->AccelLimit으로 변경 */}
                      {t("Hard acceleration event_", {
                        kmh: calcKMH(
                          current?.EventSpeedUnit ?? "0",
                          current?.AccelLimit ?? "0",
                          "11"
                        ),
                        mph: calcMPH(
                          current?.EventSpeedUnit ?? "0",
                          current?.AccelLimit ?? "0",
                          "7"
                        ),
                      })}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={clsx(classes.boderNoneBox, classes.SpdT14)}>
            <div className={classes.hardSliderDiv}>
              <div style={{ minWidth: 170 }}>
                <FormControlLabel
                  className={clsx(classes.mgNone, classes.hardLabelDiv)}
                  control={
                    <CheckBox
                      checked={current?.HarshLimit !== "0"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          handleChange(
                            "HarshLimit",
                            current?.EventSpeedUnit === "1" ? "8" : "13"
                          );
                        } else {
                          handleChange("HarshLimit", "0");
                        }
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography
                      category="Default"
                      variant="Body"
                      className={classes.hardLabel}
                    >
                      {t("Hard braking")}
                    </Typography>
                  }
                />

                <div
                  className={clsx(
                    classes.hardContentMargin,
                    classes.hardContentWeb
                  )}
                >
                  <Typography
                    category="Default"
                    variant="Small"
                    htmlColor={LightColors.primary["2"]}
                  >
                    {t("Hard braking event_", {
                      kmh: calcKMH(
                        current?.EventSpeedUnit ?? "0",
                        current?.HarshLimit ?? "0",
                        "13"
                      ),
                      mph: calcMPH(
                        current?.EventSpeedUnit ?? "0",
                        current?.HarshLimit ?? "0",
                        "8"
                      ),
                    })}
                  </Typography>
                </div>
              </div>
              <div>
                <FirmwareSlider
                  max={current?.EventSpeedUnit === "1" ? 31 : 50}
                  min={current?.EventSpeedUnit === "1" ? 6 : 10}
                  step={1}
                  mark={current?.EventSpeedUnit === "1" ? 8 : 13}
                  disabled={current?.HarshLimit === "0"}
                  value={parseInt(
                    current?.HarshLimit === undefined ||
                      current?.HarshLimit === "0"
                      ? current?.EventSpeedUnit === "1"
                        ? "8"
                        : "13"
                      : current.HarshLimit
                  )}
                  onChange={(e, value) => {
                    const v = value as number;
                    setCurrent((c) => {
                      return (
                        c && {
                          ...c,
                          HarshLimit: v.toString(),
                        }
                      );
                    });
                  }}
                />
                {mobile && (
                  <div className={classes.hardContentMobile}>
                    <Typography
                      category="Default"
                      variant="Small"
                      htmlColor={LightColors.primary["2"]}
                    >
                      {t("Hard braking event_", {
                        kmh: calcKMH(
                          current?.EventSpeedUnit ?? "0",
                          current?.HarshLimit ?? "0",
                          "13"
                        ),
                        mph: calcMPH(
                          current?.EventSpeedUnit ?? "0",
                          current?.HarshLimit ?? "0",
                          "8"
                        ),
                      })}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div
            className={clsx(classes.boderBottomBox, classes.SpdT14)}
            style={{ paddingBottom: 11 }}
          >
            <div className={classes.hardSliderDiv}>
              <div style={{ minWidth: 170 }}>
                <FormControlLabel
                  className={clsx(classes.mgNone, classes.hardLabelDiv)}
                  control={
                    <CheckBox
                      checked={current?.SharpLimit !== "0"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          handleChange(
                            "SharpLimit",
                            current?.EventSpeedUnit === "1" ? "9" : "15"
                          );
                        } else {
                          handleChange("SharpLimit", "0");
                        }
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography
                      category="Default"
                      variant="Body"
                      className={classes.hardLabel}
                    >
                      {/* osd 키값 참고 */}
                      {t("Sharp turn")}
                    </Typography>
                  }
                />

                <div
                  className={clsx(
                    classes.hardContentMargin,
                    classes.hardContentWeb
                  )}
                >
                  <Typography
                    category="Default"
                    variant="Small"
                    htmlColor={LightColors.primary["2"]}
                  >
                    {t("Hard cornering event_", {
                      kmh: calcKMH(
                        current?.EventSpeedUnit ?? "0",
                        current?.SharpLimit ?? "0",
                        "15"
                      ),
                      mph: calcMPH(
                        current?.EventSpeedUnit ?? "0",
                        current?.SharpLimit ?? "0",
                        "9"
                      ),
                    })}
                  </Typography>
                </div>
              </div>
              <div>
                <FirmwareSlider
                  max={current?.EventSpeedUnit === "1" ? 31 : 50}
                  min={current?.EventSpeedUnit === "1" ? 6 : 10}
                  step={1}
                  mark={current?.EventSpeedUnit === "1" ? 9 : 15}
                  disabled={current?.SharpLimit === "0"}
                  value={parseInt(
                    current?.SharpLimit === undefined ||
                      current?.SharpLimit === "0"
                      ? current?.EventSpeedUnit === "1"
                        ? "9"
                        : "15"
                      : current?.SharpLimit
                  )}
                  onChange={(e, value) => {
                    const v = value as number;
                    setCurrent((c) => {
                      return (
                        c && {
                          ...c,
                          SharpLimit: v.toString(),
                        }
                      );
                    });
                  }}
                />
                {mobile && (
                  <div className={classes.hardContentMobile}>
                    <Typography
                      category="Default"
                      variant="Small"
                      htmlColor={LightColors.primary["2"]}
                    >
                      {t("Hard cornering event_", {
                        kmh: calcKMH(
                          current?.EventSpeedUnit ?? "0",
                          current?.SharpLimit ?? "0",
                          "15"
                        ),
                        mph: calcMPH(
                          current?.EventSpeedUnit ?? "0",
                          current?.SharpLimit ?? "0",
                          "9"
                        ),
                      })}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      );
    }
    return <></>;
  }, [
    classes.SpdT12,
    classes.SpdT14,
    classes.SpdT21,
    classes.boderBottomBox,
    classes.boderNoneBox,
    classes.hardContentMargin,
    classes.hardContentMobile,
    classes.hardContentWeb,
    classes.hardLabel,
    classes.hardLabelDiv,
    classes.hardSliderDiv,
    classes.mgNone,
    current?.AccelEvent,
    current?.AccelLimit,
    current?.EventSpeedUnit,
    current?.HarshEvent,
    current?.HarshLimit,
    current?.SharpEvent,
    current?.SharpLimit,
    handleChange,
    mobile,
    settings,
    t,
  ]);

  const renderSimpleCheckBox = useCallback(
    (
      label: string,
      key1: keyof ISystemConfig,
      key: keyof TabNameInfo3,
      options?: { className?: string; checkFn?: () => boolean }
    ) => {
      const set = settings as any;
      if (set[key1][key]) {
        return (
          <div className={clsx(classes.boderNoneBox, options?.className)}>
            <FormControlLabel
              className={classes.mgNone}
              control={
                <CheckBox
                  checked={getBoolean(current?.[key] as TrueFalsetype)}
                  onChange={(e) => {
                    handleChange(key, e.target.checked);
                  }}
                  color="primary"
                />
              }
              label={
                <Typography category="Default" variant="Body">
                  {t(label)}
                </Typography>
              }
            />
          </div>
        );
      }
      return undefined;
    },
    [
      settings,
      classes.boderNoneBox,
      classes.mgNone,
      getBoolean,
      current,
      t,
      handleChange,
    ]
  );

  return (
    <>
      <div>
        <div className={classes.bigBox}>
          {settings?.["LED"] && (
            <div>
              <div className={clsx(classes.boderNoneBox, classes.title)}>
                <Typography category="Default" variant="BodyBold">
                  {t("LED")}
                </Typography>
              </div>
              {renderSimpleCheckBox("Recording status", "LED", "RECLED")}
              {renderSimpleCheckBox(
                "Front security (Normal mode)",
                "LED",
                "NORMALLED"
              )}
              {renderSimpleCheckBox(
                "Front security (Parking mode)",
                "LED",
                "PARKINGLED"
              )}
              {renderSimpleCheckBox("Rear security", "LED", "RearLED")}
              {renderSimpleCheckBox("BT (Parking mode)", "LED", "BTLED")}
              {OPTION_MODEL
                ? renderSimpleCheckBox(
                    "Option camera security",
                    "LED",
                    "OptionRearLED"
                  )
                : renderSimpleCheckBox(
                    "Interior security",
                    "LED",
                    "InteriorLED"
                  )}

              {!DR7500GPRO_BT_ORDER &&
                renderSimpleCheckBox("LTE (Parking mode)", "LED", "LTELED")}
              {renderSimpleCheckBox("Wi-Fi (Parking mode)", "LED", "WifiLED")}
              {DR7500GPRO_BT_ORDER &&
                renderSimpleCheckBox("LTE (Parking mode)", "LED", "LTELED")}
            </div>
          )}
          {settings?.["PSENSOR"] && (
            <div className={clsx(classes.boderBottomBox, classes.SpdT12)}>
              <FormControlLabel
                className={classes.mgNone}
                control={
                  <CheckBox
                    checked={
                      PSENSORMODEL
                        ? current?.PSENSOR === "0" || current?.PSENSOR === "1"
                        : current?.PSENSOR === "1" || current?.PSENSOR === "2"
                    }
                    onChange={(e) => {
                      if (PSENSORMODEL) {
                        handleChangePSENSOR_MODEL("PSENSOR", e.target.checked);
                      } else if (SigmaStar_MODEL) {
                        handleChangeTSENSOR("PSENSOR", e.target.checked);
                      } else {
                        handleChangePSENSOR("PSENSOR", e.target.checked);
                      }
                    }}
                    color="primary"
                  />
                }
                label={
                  <Typography category="Default" variant="Body">
                    {t(PSensorTitle)}
                  </Typography>
                }
              />
              <div className={classes.SflexEnd}>
                <div className={clsx(FILE_LOCKED && classes.Width270)}>
                  <Selector
                    t={t}
                    disabled={
                      PSENSORMODEL
                        ? current?.PSENSOR === "2"
                        : current?.PSENSOR === "0"
                    }
                    keyValue={current?.PSENSOR}
                    dense
                    menuScrollTime
                    mobile={mobile}
                    onChange={(e) => {
                      setCurrent((c) => {
                        return c && { ...c, PSENSOR: e.key };
                      });
                    }}
                    items={SigmaStar_MODEL ? TSENSOROptions : PSENSOROptions}
                  />
                </div>
              </div>
            </div>
          )}

          {settings?.["VoiceGuidance"] && (
            <div>
              <div
                className={clsx(classes.boderNoneBox, classes.voiceFlex)}
                style={{ paddingLeft: 16 }}
              >
                <Typography category="Default" variant="BodyBold">
                  {t("Voice guidance")}
                </Typography>
              </div>
              {renderSimpleCheckBox("Power on", "VoiceGuidance", "STARTVOICE")}
              {renderSimpleCheckBox(
                "Starting normal recording",
                "VoiceGuidance",
                "NORMALSTARTVOICE"
              )}
              {/* mantis - 11089, 문구 펌웨어 설정표 기준으로 수정 Start event recording (beep) -> Starting Event Recording (Beep) (Leehj) */}
              {renderSimpleCheckBox(
                "Start event recording (beep)",
                "VoiceGuidance",
                "EVENTSTARTVOICE"
              )}
              {renderSimpleCheckBox(
                "Changing recording mode",
                "VoiceGuidance",
                "CHANGERECORDMODEVOICE"
              )}
              {renderSimpleCheckBox(
                "Settings have been changed",
                "VoiceGuidance",
                "CHANGECONFIGVOICE"
              )}
              {renderSimpleCheckBox("Power off", "VoiceGuidance", "ENDVOICE")}
              {renderSimpleCheckBox(
                "Speed alert (beep)",
                "VoiceGuidance",
                "SPEEDALERTVOICE"
              )}
              {renderSimpleCheckBox(
                "Hard acceleration alert (beep)",
                "VoiceGuidance",
                "ACCELERATIONVOICE"
              )}
              {renderSimpleCheckBox(
                "Hard braking alert (beep)",
                "VoiceGuidance",
                "HARSHBRAKINGVOICE"
              )}
              {renderSimpleCheckBox(
                "Hard cornering alert (beep)",
                "VoiceGuidance",
                "SHARPTURNVOICE"
              )}
              {renderSimpleCheckBox(
                "Impact detected in_",
                "VoiceGuidance",
                "PARKINGEVENTVOICE"
              )}
              {renderSimpleCheckBox(
                "Cloud related",
                "VoiceGuidance",
                "CLOUDVOICE"
              )}
            </div>
          )}
          {settings?.["VOLUME"] && (
            <div
              className={clsx(classes.boderBottomBoxSpace, classes.volumeT12)}
            >
              <div>
                <Typography category="Default" variant="Body">
                  {t("Volume")}
                </Typography>
              </div>
              <div className={classes.wid224}>
                <Sliders
                  max={5}
                  value={parseInt(current?.VOLUME ?? "0")}
                  onChange={(e, value) => {
                    const v = value as number;
                    setCurrent((c) => {
                      return (
                        c && {
                          ...c,
                          VOLUME: v.toString(),
                        }
                      );
                    });
                  }}
                ></Sliders>
                <Typography
                  category="Default"
                  variant="Small"
                  className={classes.sliderText}
                >
                  {current && parseInt(current.VOLUME)}
                </Typography>
              </div>
            </div>
          )}
          {settings?.["ScheduledReboot"] && (
            <div className={clsx(classes.boderBottomBox, classes.SpdT12)}>
              <FormControlLabel
                className={classes.mgNone}
                control={
                  <CheckBox
                    checked={getBoolean(current?.ScheduledReboot)}
                    onChange={(e) => {
                      handleChange("ScheduledReboot", e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label={
                  <Typography category="Default" variant="Body">
                    {t("Scheduled reboots")}
                  </Typography>
                }
              />
              <div className={classes.flexEnd}>
                <div className={classes.Swid100}>
                  <Selector
                    t={t}
                    menuScrollTime
                    disabled={current?.ScheduledReboot !== "1"}
                    dense
                    mobile={mobile}
                    keyValue={current?.ScheduledRebootTime}
                    onChange={(e) => {
                      setCurrent((c) => {
                        return c && { ...c, ScheduledRebootTime: e.key };
                      });
                    }}
                    items={_.map(ScheduledRebootTime, (val, key) => {
                      return {
                        key: key,
                        value: val,
                      };
                    })}
                  />
                </div>
              </div>
            </div>
          )}
          {speedAlertMarkup}
          {eventRevMarkup}
          {/* ADAS */}
          {settings?.["ADAS"] && (
            <>
              <div className={clsx(classes.boderNoneBox, classes.adasT8)}>
                <FormControlLabel
                  className={classes.mgNone}
                  control={
                    <CheckBox
                      checked={getBoolean(current?.ADASSetting)}
                      onChange={(e) => {
                        handleChange("ADASSetting", e.target.checked);
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography category="Default" variant="BodyBold">
                      {t("ADAS")}
                    </Typography>
                  }
                />
              </div>
              <div
                className={classes.boderNoneBox}
                style={{ paddingRight: 14 }}
              >
                <FormControlLabel
                  className={classes.mgNone}
                  control={
                    <CheckBox
                      disabled={current?.ADASSetting === "0"}
                      checked={current?.ADASLDWS !== "0"}
                      onChange={(e) => {
                        handleChange("ADASLDWS", e.target.checked);
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography category="Default" variant="Body">
                      {t("LDWS")}
                    </Typography>
                  }
                />
                <div
                  className={clsx(classes.flexEnd, classes.adasT10)}
                  style={{ paddingBottom: 10 }}
                >
                  <div style={{ maxWidth: 117 }}>
                    <Selector
                      t={t}
                      disabled={
                        current?.ADASSetting === "0" ||
                        current?.ADASLDWS === "0"
                      }
                      keyValue={current?.ADASLDWS}
                      onChange={(e) => {
                        setCurrent((c) => {
                          return c && { ...c, ADASLDWS: e.key };
                        });
                      }}
                      dense
                      mobile={mobile}
                      items={_.map(ADASLDWS, (val, key) => {
                        return {
                          key: key,
                          value: val,
                        };
                      })}
                    />
                  </div>
                </div>
              </div>
              <div className={clsx(classes.boderBottomBox, classes.adsT2)}>
                <FormControlLabel
                  className={classes.mgNone}
                  control={
                    <CheckBox
                      disabled={current?.ADASSetting === "0"}
                      checked={getBoolean(current?.ADASFVSA)}
                      onChange={(e) => {
                        handleChange("ADASFVSA", e.target.checked);
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography category="Default" variant="Body">
                      {t("FVSA")}
                    </Typography>
                  }
                />
              </div>
            </>
          )}

          {/* 기존 Battery protection UI */}
          {settings?.["BatteryProtection"] && (
            <>
              <div className={clsx(classes.boderNoneBox, classes.adasT8)}>
                <FormControlLabel
                  className={classes.mgNone}
                  control={
                    <CheckBox
                      checked={current?.Battery !== "0"}
                      onChange={(e) => {
                        if (BATTERY_PROTECTION_MODAL) {
                          setOpenBatteryModal(true);
                          setSelectedField("Battery");
                          setSelectedValue(e.target.checked);
                        } else {
                          handleChange("Battery", e.target.checked);
                        }
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography category="Default" variant="BodyBold">
                      {t("Battery protection")}
                    </Typography>
                  }
                />
              </div>

              <div
                className={classes.boderBottomBox}
                style={{ border: "none" }}
              >
                <FormControlLabel
                  className={classes.mgNone}
                  control={
                    <CheckBox
                      disabled={current?.Battery === "0"}
                      checked={current?.LowvoltageVolt !== "0"}
                      onChange={(e) => {
                        if (BATTERY_PROTECTION_MODAL) {
                          setOpenBatteryModal(true);
                          setSelectedField("LowvoltageVolt");
                          setSelectedValue(e.target.checked);
                        } else {
                          handleChangeLowVolt(
                            "LowvoltageVolt",
                            e.target.checked
                          );
                        }
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography category="Default" variant="Body">
                      {t("Low voltage cut-off")}
                    </Typography>
                  }
                />
                <div className={classes.flexEnd}>
                  <div className={classes.Swid116} style={{ maxWidth: 161 }}>
                    <Selector
                      t={t}
                      keyValue={
                        current?.LowvoltageVolt === "0"
                          ? "2"
                          : current?.LowvoltageVolt
                      }
                      disabled={
                        current?.LowvoltageVolt === "0" ||
                        current?.Battery === "0"
                      }
                      open={openBatteryLowVolt}
                      onClick={() => {
                        if (BATTERY_PROTECTION_MODAL && !batteryPRevChanged) {
                          setOpenBatteryModal(true);
                          setSelectedField("LowvoltageVolt");
                          setSelectedValue(undefined);
                        }
                      }}
                      onChange={(e) => {
                        setCurrent((c) => {
                          return c && { ...c, LowvoltageVolt: e.key };
                        });
                      }}
                      dense
                      mobile={mobile}
                      items={
                        BATTERY_PROTECTION_MODAL
                          ? _.map(LowvoltageVolt_GPRO, (val, key) => {
                              return {
                                key: key,
                                value: val,
                              };
                            })
                          : _.map(LowvoltageVolt, (val, key) => {
                              return {
                                key: key,
                                value: val,
                              };
                            })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className={classes.boderBottomBox}>
                <FormControlLabel
                  className={classes.mgNone}
                  control={
                    <CheckBox
                      checked={current?.LowvoltageTime !== "0"}
                      disabled={current?.Battery === "0"}
                      onChange={(e) => {
                        if (BATTERY_PROTECTION_MODAL) {
                          setOpenBatteryModal(true);
                          setSelectedField("LowvoltageTime");
                          setSelectedValue(e.target.checked);
                        } else {
                          handleChange("LowvoltageTime", e.target.checked);
                        }
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography category="Default" variant="Body">
                      {t("Cut-off timer")}
                    </Typography>
                  }
                />
                <div className={classes.flexEnd}>
                  <div className={classes.Swid98}>
                    <Selector
                      t={t}
                      keyValue={current?.LowvoltageTime}
                      disabled={
                        current?.LowvoltageTime === "0" ||
                        current?.Battery === "0"
                      }
                      open={openCutoff}
                      onClick={() => {
                        if (
                          BATTERY_PROTECTION_MODAL &&
                          !cutoffTimerRevChanged
                        ) {
                          setOpenBatteryModal(true);
                          setSelectedField("LowvoltageTime");
                          setSelectedValue(undefined);
                        }
                      }}
                      onChange={(e) => {
                        setCutoffTimerRevChanged(true);
                        setCurrent((c) => {
                          return c && { ...c, LowvoltageTime: e.key };
                        });
                        console.log(e);
                      }}
                      dense
                      mobile={mobile}
                      items={_.map(LowvoltageTime, (val, key) => {
                        return {
                          key: key,
                          value: val,
                        };
                      })}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* 2021.09.03 REV 부터 적용되는 신규 Battery protection UI */}
          {batteryRevMarkup}
          {/* DMS */}
          {settings?.["DMS"] && current && (
            <DMSPanel tabInfo3={current} onChange={handleChange} />
          )}

          {settings?.["Seamless"] && (
            <div
              className={clsx(classes.boderBottomBox, classes.SpdT12)}
              style={{ paddingTop: 6, paddingBottom: 6 }}
            >
              <div>
                <FormControlLabel
                  className={classes.mgNone}
                  control={
                    <CheckBox
                      checked={current?.BTPair === "1"}
                      onChange={(e) => {
                        handleChange("BTPair", e.target.checked);
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography category="Default" variant="Body">
                      {t("Seamless pairing")}
                    </Typography>
                  }
                />

                <div style={{ marginLeft: 32 }}>
                  <Typography
                    category="Default"
                    variant="Small"
                    htmlColor={LightColors.primary["2"]}
                  >
                    {t("When OFF, connecting_")}
                  </Typography>
                </div>
              </div>
            </div>
          )}

          {settings?.["UserTextOverlay"] && (
            <div className={classes.boxSpaceNoneCenter}>
              <div style={{ minWidth: 120, display: "flex" }}>
                <Typography
                  category="Default"
                  variant="Body"
                  style={{
                    margin: "12px 0",
                    [theme.breakpoints.up(Webviewer.mobile)]: {
                      marginBottom: 0,
                      width: 118,
                    },
                  }}
                >
                  {t("User text overlay")}
                </Typography>
              </div>
              <div>
                <div className={classes.inputStyle}>
                  <Input
                    dense
                    placeholder={t("Enter your text")}
                    onChange={handleInput}
                    value={current?.userString}
                    helperText={
                      <div className={classes.spaceBetween}>
                        <div className={classes.flex1}>{t("A-Z, a-z_")}</div>
                        <div className={classes.flex}>
                          {current?.userString.length ?? 0} / 20
                        </div>
                      </div>
                    }
                  ></Input>
                </div>
              </div>
            </div>
          )}
        </div>

        <Button
          className={classes.buttonSize}
          variant="contained"
          color="primary"
          disabled={disabledChange}
          loading={loading}
          onClick={handleUpdate}
        >
          {t("Save")}
        </Button>
      </div>
      <Modal
        open={openBatteryModal}
        heading={t("Warning")}
        content={
          <Typography
            category="Default"
            variant="Body"
            dangerouslySetInnerHTML={{
              __html: t("Adjusting the cut-off voltage_").replaceAll(
                "\n",
                "<br/>"
              ),
            }}
          />
          // <Typography category="Default" variant="Body">
          //   {t(`Adjusting the cut-off voltage_`)}
          // </Typography>
        }
        LButton={t("Cancel")}
        RButton={t("Continue")}
        Secondary
        onClickNegative={() => setOpenBatteryModal(false)}
        onClickPositive={() => {
          if (selectedField === "Battery") {
            handleChange(selectedField, selectedValue);
          } else if (selectedField === "LowvoltageVolt") {
            if (selectedValue !== undefined) {
              if (settings?.["BatteryProtectionRev"]) {
                handleChangeLowVoltRev(selectedField, selectedValue);
              } else {
                handleChangeLowVolt(selectedField, selectedValue);
              }
            } else {
              setBatteryPRevChanged(true);
            }
          } else if (selectedField === "LowvoltageTime") {
            if (selectedValue !== undefined) {
              if (settings?.["BatteryProtectionRev"]) {
                handleChangeCutoffTimerRev(selectedField, selectedValue);
              } else {
                handleChange(selectedField, selectedValue);
              }
            } else {
              setCutoffTimerRevChanged(true);
            }
          } else if (selectedField === "LowvoltageVoltHeavy") {
            setBatteryHRevChanged(true);
          }
          setOpenBatteryModal(false);
        }}
      />
    </>
  );
};
